import { useState } from 'react';
import { CampoFormik } from '../../../CompUtils';
import FormSection from '../../../CompUtils/FormSection';
import { Formik } from 'formik';
import * as yup from 'yup';
import es from '../../../../yup-es';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { CONCURSOAPI } from '../../../../const';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { finalize, init } from '../../../GlobalFeedback/feedbackSlice';
import { AlertaDialog } from '../../../CompUtils/Alerta';
import { PuestosTable } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTable';
import { useHistory } from 'react-router-dom';
import { getPuestos } from '../../../../appStore/denominaciones';

export const CargaPuestos = ({ idLlamadoConcurso = null, showAvanzarConcurso }) => {
  const [alert, setAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();
  const FILE_TYPES = ['xlsx', 'xls'];
  function validarTipoArchivoPermitido(value) {
    if (value.name) return FILE_TYPES.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES.includes(value.split('.').pop());
    return false;
  }
  yup.setLocale(es);
  const schema = yup.object({
    puestosFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoPermitido(value),
      ),
  });
  const initial = {
    puestosFile: {},
  };
  const onShowAvanzarConcurso = (value) => {
    value && showAvanzarConcurso(value);
  };
  const handleSubmit = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.puestosFile) {
      formData.append('file', copy.puestosFile);
    }

    axios
      .post(`${CONCURSOAPI}/puesto/loadfile/${idLlamadoConcurso}`, formData)
      .then((res) => {
        dispatch(finalize());
        dispatch(getPuestos({ idLlamadoConcurso }));
        onShowAvanzarConcurso(true);
        setAlert(true);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  const finalizarConfirmacion = () => {
    setAlert(false);
    history.go();
  };

  return (
    <>
      <hr></hr>
      <h3 className="text-center">Carga de Denominaciones</h3>
      <Formik
        validationSchema={schema}
        validateOnChange={false}
        initialValues={initial}
        onSubmit={handleSubmit}>
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit} id="cargaPuestosForm">
            <Form.Group as={Row} className="align-items-center">
              <Col sm="5">
                <CampoFormik
                  type="file"
                  label="Archivo de Denominaciones a importar"
                  name="puestosFile"
                  formik={formik}
                  col={{ sm: 4 }}
                />
              </Col>

              <Col sm="1">
                <Button variant="primary" type="submit">
                  <i className="icono-arg-nube-subir-datos"></i>
                </Button>
              </Col>
              <Col sm="5">
                <p className="text-danger">
                  <small>{errorMsg}</small>
                </p>
              </Col>
            </Form.Group>
          </Form>
        )}
      </Formik>

      <FormSection></FormSection>
      <PuestosTable
        idLlamadoConcurso={idLlamadoConcurso}
        onShowAvanzarConcurso={(value) => onShowAvanzarConcurso(value)}
      />
      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>Datos ingresados correctamente</p>
        </div>
      </AlertaDialog>
    </>
  );
};
